var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyGoec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6016 36.3799C33.1686 34.4327 35.7635 32.3989 37.3705 29.6061C39.0469 26.6927 39.9873 23.2992 39.9873 19.6767C39.9873 8.82896 31.2569 0.0351562 20.4873 0.0351562C9.71775 0.0351562 0.987305 8.82896 0.987305 19.6767C0.987305 25.0447 3.05224 29.9097 6.51716 33.455L18.7472 43.1127C19.4239 44.2003 20.9918 44.2153 21.6888 43.1407L30.6016 36.3799Z",
    fill: "#929393"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4869,
    cy: 19.2173,
    r: 16.9634,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8152 21.2921L30.2316 16.2895C31.4894 20.4125 29.9841 25.0302 26.2244 27.559C21.6193 30.665 15.3646 29.4487 12.2578 24.8378C9.1511 20.2338 10.3746 13.9807 14.9797 10.8746C18.327 8.62078 22.5403 8.64139 25.7776 10.5929L30.479 7.42509C25.3584 3.13721 17.8252 2.54625 12.0104 6.46306C4.97211 11.2182 3.10945 20.7767 7.8589 27.8132C12.6084 34.8566 22.1623 36.712 29.2006 31.9706C35.4072 27.7857 37.5929 19.8765 34.7679 13.2316C34.3899 12.3383 33.9225 11.4656 33.3589 10.6273C32.919 9.97449 32.4448 9.36979 31.9224 8.81319L19.8803 16.9354C18.6775 17.7463 18.3614 19.3817 19.1724 20.5843C19.9834 21.7799 21.6124 22.1029 22.8152 21.2921Z",
    fill: "#929393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1796 17.6957L21.0428 23.4274C21.0909 23.503 21.194 23.5167 21.2628 23.4686L24.3699 21.3725C24.4455 21.3244 24.4592 21.2213 24.4112 21.1526L20.5479 15.4209C20.4998 15.3453 20.3966 15.3315 20.3279 15.3796L17.2208 17.4757C17.1521 17.5238 17.1314 17.6201 17.1796 17.6957Z",
    fill: "#929393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5643 20.6839C15.6948 20.8764 15.9626 20.9314 16.1549 20.8008L18.4833 19.2265C18.6756 19.0959 18.7306 18.8278 18.6 18.6353C18.4696 18.4428 18.2017 18.3878 18.0094 18.5185L15.681 20.0927C15.4887 20.2233 15.4338 20.4846 15.5643 20.6839Z",
    fill: "#929393"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7672 21.4378C17.8977 21.6303 18.1654 21.6853 18.3576 21.5547L20.6846 19.9804C20.8768 19.8498 20.9317 19.5817 20.8013 19.3892C20.6708 19.1968 20.4031 19.1417 20.2109 19.2724L17.8839 20.8466C17.6848 20.9772 17.6368 21.2385 17.7672 21.4378Z",
    fill: "#929393"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.662 23.8031C17.7929 23.9955 18.0616 24.0505 18.2545 23.9199L20.5902 22.3457C20.7831 22.2151 20.8382 21.947 20.7073 21.7545C20.5764 21.562 20.3077 21.507 20.1148 21.6376L17.7791 23.2119C17.5793 23.3425 17.5311 23.6037 17.662 23.8031Z",
    fill: "#929393"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0499 18.082L20.4041 18.7896L20.7347 19.3117L19.2129 19.93L21.6299 19.6483L21.2856 19.1262L22.6145 18.9614L22.0499 18.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyGoec);
export default __webpack_public_path__ + "static/media/greyGoec.9a8ded45d409b201d021a17ac37cba4e.svg";
export { ForwardRef as ReactComponent };